import { z } from "zod";
import superjson from "superjson";
import { UserRole } from "../../helpers/schema";

export const schema = z.object({});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  members: Array<{
    id: number;
    role: UserRole;
    joinedAt: Date | null;
    user: {
      id: number;
      email: string;
      displayName: string;
      avatarUrl: string | null;
    };
  }>;
};

export const getOrganizationMembers = async (
  body: InputType = {},
  init?: RequestInit
): Promise<OutputType> => {
  const result = await fetch(`/_api/organizations/members`, {
    method: "GET",
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};